class ClinicalTriages {
  constructor(note, priority, chiefComplaintId) {
    this.note = note;
    this.priority = priority;
    this.chiefComplaintId = chiefComplaintId;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      chiefComplaintAdviceId: null,
      searchTitle: '',
      disabelConfirm: false,
      addFlag: false,
      modalTitle: '',
      showAddEditModal: false,
      modalIcon: '',

      clinicalTriageManagmentInformationTableHeaders: [
        { text: 'اولویت', value: 'priority', align: 'center' },
        { text: 'توضیحات', value: 'note', align: 'center' },
        { text: 'عملیات', value: 'actions', sortable: false, align: 'center' },
      ],

      chiefComplaintId: null,
    };
  },
  methods: {
    onValidate: function () {
      if (!this.chiefComplaintAdvice.note) {
        this.snackText = 'عنوان توصیه/راهنما نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaintAdvice.note.replace(/\s/g, '').length) {
        this.snackText = 'عنوان توصیه/راهنما نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.chiefComplaintAdvice.priority?.toString()) {
        this.snackText = 'اولویت نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      return true;
    },
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.modalTitle = 'افزودن توصیه/راهنما';
        this.modalIcon = 'mdi-plus';
        this.addFlag = true;
        this.confimType = 'add';
        this.showAddEditModal = true;
      } else if (type == 2) {
        this.modalTitle = 'ویرایش توصیه/راهنما';
        this.modalIcon = 'mdi-pencil';
        this.confimType = 'edit';
        this.addFlag = false;
        this.getAdviceGuidanceAdvice(id);
        this.showAddEditModal = true;
      }
    },
    cancelAddEditFunction: function () {
      this.chiefComplaintAdvice = new ClinicalTriages('', null, null);
      this.showAddEditModal = false;
    },
    // change status advice
    changeAdviceStatus: function (type, id) {
      this.chiefComplaintAdviceId = id;
      this.confimType = type === 1 ? 'activate' : 'deactivate';
      this.showConfirmDialogFunction();
    },
    showConfirmDialogFunction: function () {
      switch (this.confimType) {
        case 'add':
          this.addAdviceGuidance();
          break;
        case 'edit':
          this.$refs.confirm.showConfirmDialog = true;
          this.$refs.confirm.title = 'ویرایش توصیه/راهنما';
          this.$refs.confirm.text = 'از ویرایش توصیه/راهنما اطمینان دارید؟';
          break;
        case 'delete':
          this.$refs.confirm.title = 'حذف توصیه/راهنما';
          this.$refs.confirm.text = 'از حذف توصیه/راهنما اطمینان دارید؟';
          this.$refs.confirm.showConfirmDialog = true;
          break;
        case 'activate':
          this.$refs.confirm.title = 'فعال سازی توصیه/راهنما';
          this.$refs.confirm.text = 'از فعال سازی توصیه/راهنما اطمینان دارید؟';
          this.$refs.confirm.showConfirmDialog = true;
          break;
        case 'deactivate':
          this.$refs.confirm.title = 'غیرفعال سازی توصیه/راهنما';
          this.$refs.confirm.text = 'از غیرفعال سازی توصیه/راهنما اطمینان دارید؟';
          this.$refs.confirm.showConfirmDialog = true;
          break;
        default:
          break;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },

    confirmDialogConfirmFunction: function () {
      this.disabelConfirm = true;
      switch (this.confimType) {
        case 'edit':
          this.editAdviceGuidance();
          break;
        case 'delete':
          this.deleteAdviceGuidance(this.chiefComplaintAdviceId);
          break;
        case 'activate':
          this.activateAdviceGuidance(this.chiefComplaintAdviceId);
          break;
        case 'deactivate':
          this.deactivateAdviceGuidance(this.chiefComplaintAdviceId);
          break;
        default:
          return;
      }
    },
    confirmDialogCancelFunction: function () {
      this.$refs.confirm.showConfirmDialog = false;
      this.disabelConfirm = false;
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.chiefComplaintAdviceId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
    backToChiefComplaintPage: function () {
      this.$router.push({ name: 'chiefComplaint' });
    },
  },
  computed: {
    filterdAllClinicalTriages: function () {
      return [...this.allChiefComplaintAdvices]?.filter(({ note }) =>
        note.includes(this.searchTitle),
      );
    },
  },
};
